<p>my-courses works!</p>
